import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function Register() {
  const location = useLocation();
  const navigate = useNavigate();
  const { email, nickname, profile_image } = location.state || {};

  const [phone, setPhone] = useState('');
  const [userNickname, setUserNickname] = useState(nickname || '');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // 서버로 회원가입 정보 전송
    fetch('http://localhost:3000/user/register', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, nickname: userNickname, phone }),
    })
      .then(res => res.json())
      .then(result => {
        if (result.success) {
          navigate('/home'); // 가입 성공 후 메인 화면으로 이동
        } else {
          alert("회원가입 실패: " + result.message);
        }
      })
      .catch(err => {
        console.error(err);
        alert("회원가입 요청 중 오류가 발생했습니다.");
      });
  };

  const handleNicknameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserNickname(e.target.value);
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPhone(e.target.value);
  };

  return (
    <div>
      <h2>회원가입 추가 정보 입력</h2>
      <form onSubmit={handleSubmit}>
        <label>이메일</label>
        <input type="email" value={email} readOnly />

        <label>닉네임</label>
        <input
          type="text"
          value={userNickname}
          onChange={handleNicknameChange}
        />

        <label>전화번호</label>
        <input
          type="tel"
          value={phone}
          placeholder="전화번호 입력"
          onChange={handlePhoneChange}
        />

        <label>프로필 이미지</label>
        <img src={profile_image} alt="네이버 프로필" style={{ width: 50, height: 50 }} />

        <button type="submit">가입 완료하기</button>
      </form>
    </div>
  );
}

export default Register;
